import React from 'react';
import { useIntl } from '../../util/reactIntl';

import OptionCard from './OptionCard';

import css from './QuestionStep.module.css';

function QuestionStep({
  question,
  selected,
  updateAnswer,
}) {
  const intl = useIntl();

  return (
    <div className={css.root}>
      <div className={css.question}>
        {intl.formatMessage({ id: question.title })}
      </div>

      <div className={css.optionsContainer}>
        {question.options.map(option => (
          <OptionCard
            key={option.value}
            label={intl.formatMessage({ id: option.label })}
            subtitle={intl.formatMessage({ id: option.subtitle })}
            selected={selected === option.value}
            variant="large"
            onClick={() =>
              updateAnswer(question.id, option.value)
            }
          />
        ))}
      </div>
    </div>
  );
}

export default QuestionStep;